<template>
  <div>
    <el-dialog
      ref="connectStoreDialog"
      v-dialogDrag
      title="微信群成员认证零售户档案"
      :visible.sync="dialogVisible"
      :class="{'abow_dialog': true, 'h760_dialog': (dialogViewForm.storeId !== 0 && dialogViewForm.appUserId === 0) || (dialogViewForm.storeId === 0 && dialogViewForm.appUserId !== 0), 'h700_dialog': dialogViewForm.storeId === 0 && dialogViewForm.appUserId === 0}"
      width="1100px"
      :before-close="modalClose"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      append-to-body
    >
      <el-form
        ref="dialogConnectForm"
        :model="dialogConnectForm"
        class="add-edit-view-form"
        @submit.native.prevent
      >
        <div class="modal-box">
          <h3 class="modal-title">
            基础信息
          </h3>
          <div class="modal-row-box">
            <el-row :gutter="10">
              <el-col :span="6">
                <el-form-item label="成员微信号">
                  <el-input
                    v-model="dialogViewForm.userName"
                    disabled
                  />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="昵称">
                  <el-input
                    v-model="dialogViewForm.nickname"
                    disabled
                  />
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="所在微信群">
                  <el-input
                    v-model="dialogViewForm.groupNames"
                    disabled
                  />
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="10">
              <el-col :span="6">
                <el-form-item label="腾讯问卷用户ID">
                  <el-input
                    v-model="dialogViewForm.questionnaireUid"
                    disabled
                  />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="问卷填写门店名称">
                  <el-input
                    v-model="dialogViewForm.questionnaireStoreName"
                    disabled
                  />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="问卷填写专卖证号">
                  <el-input
                    v-model="dialogViewForm.questionnaireCertificateNo"
                    disabled
                  />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="问卷填写本香注册手机号">
                  <el-input
                    v-model="dialogViewForm.questionnaireBxPhone"
                    disabled
                  />
                </el-form-item>
              </el-col>
            </el-row>
            <el-row
              v-if="dialogViewForm.storeId > 0"
              :gutter="10"
            >
              <el-col :span="6">
                <el-form-item label="认证零售户门店名称">
                  <el-input
                    v-model="dialogViewForm.certificatedStoreName"
                    disabled
                  />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="认证零售户专卖证号">
                  <el-input
                    v-model="dialogViewForm.storeCertificateNo"
                    disabled
                  />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="认证零售户档位">
                  <el-input
                    v-model="dialogViewForm.storeLevel"
                    disabled
                  />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="认证零售户维护状态">
                  <el-input
                    v-model="dialogViewForm.storeStatusValue"
                    disabled
                  />
                </el-form-item>
              </el-col>
            </el-row>
            <el-row
              v-if="dialogViewForm.appUserId > 0"
              :gutter="10"
            >
              <el-col :span="6">
                <el-form-item label="瑞零售注册用户OPENID">
                  <el-input
                    v-model="dialogViewForm.wxOpenId"
                    disabled
                  />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="瑞零售用户名称">
                  <el-input
                    v-model="dialogViewForm.appUserName"
                    disabled
                  />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="瑞零售用户专卖证号">
                  <el-input
                    v-model="dialogViewForm.appUserCertificateNo"
                    disabled
                  />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="瑞零售用户电话">
                  <el-input
                    v-model="dialogViewForm.appUserPhone"
                    disabled
                  />
                </el-form-item>
              </el-col>
            </el-row>
          </div>
        </div>

        <div class="modal-box">
          <h3 class="modal-title">
            零售户档案清单
          </h3>
          <div class="modal-row-box">
            <div class="searchCondition">
              <el-row :gutter="10">
                <el-col :span="4">
                  <el-input
                    v-model="tableQuery.likeStoreName"
                    placeholder="门店名称"
                    clearable
                    @keyup.enter.native="searchTableData"
                  />
                </el-col>
                <el-col :span="4">
                  <el-input
                    v-model="tableQuery.likeCertificateNo"
                    placeholder="专卖证号"
                    clearable
                    @keyup.enter.native="searchTableData"
                  />
                </el-col>
                <el-col :span="4">
                  <el-input
                    v-model="tableQuery.likePhone"
                    placeholder="联系电话"
                    clearable
                    @keyup.enter.native="searchTableData"
                  />
                </el-col>
                <el-col :span="3">
                  <el-select
                    v-model="tableQuery.status"
                    clearable
                    placeholder="请选择状态"
                    style="width:100%"
                  >
                    <el-option
                      label="维护中"
                      :value="1"
                    />
                    <el-option
                      label="停止维护"
                      :value="2"
                    />
                  </el-select>
                </el-col>
                <el-col :span="2">
                  <el-button
                    type="primary"
                    @click="searchTableData"
                  >
                    查询
                  </el-button>
                </el-col>
                <el-col
                  :span="7"
                  style="color: red; font-weight: 700;"
                >
                  <div style="margin-top: 8px;">
                    一次最多查询{{ tableQuery.limit }}条记录，所以请尽量完善查询条件
                  </div>
                </el-col>
              </el-row>
            </div>

            <el-table
              :data="storeDataList"
              border
              stripe
              :header-cell-style="{background:theme()}"
              style="width: 100%; margin: 5px 0;"
              height="315"
              class="connect-store-table"
            >
              <el-table-column
                label="选择"
                align="center"
                width="55"
              >
                <template slot-scope="scope">
                  <el-radio
                    v-model="currentRow"
                    :label="scope.$index"
                    @change.native="getCurrentRow(scope.row)"
                  />
                </template>
              </el-table-column>
              <el-table-column
                v-for="(column, index) in storeTableColumns"
                :key="index"
                resizable
                show-overflow-tooltip
                :width="column.width ? column.width : ''"
                :label="column.label"
                :prop="column.prop"
                :align="column.align || ''"
                header-align="center"
              >
                <template slot-scope="scope">
                  {{ scope.row[column.prop] }}
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </el-form>

      <div
        slot="footer"
        class="dialog-footer"
      >
        <el-button
          type="primary"
          @click="handleSave"
        >
          保存
        </el-button>
        <el-button @click="modalClose">
          关闭
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
// dialog拖拽Mixin
import dialogDragMixin from '@/mixin/dialogDragMixin'
// 微信联系人API
import { viewWeChatContactApi, connectStoreWeChatContactApi } from '@/api/v2/weChatContact'
// 零售户档案API
import { listStoreInfoApi } from '@/api/v2/store'

export default {
  components: {},
  mixins: [dialogDragMixin],
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    },
    dataId: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      dialogViewForm: {},
      dialogConnectForm: {},
      tableQuery: {
        likeStoreName: '',
        likeCertificateNo: '',
        likePhone: '',
        status: '',
        limit: 500
      },
      storeTableColumns: [
        { label: '省区', prop: 'provinceName', width: 80 },
        { label: '城市', prop: 'cityName', width: 80 },
        { label: '门店名称(专卖证)', prop: 'storeName' },
        { label: '实际门店名称', prop: 'realStoreName' },
        { label: '专卖证号', prop: 'certificateNo', width: 110 },
        { label: '店主', prop: 'ownerName', width: 80 },
        { label: '联系电话', prop: 'phone', width: 100 },
        { label: '本香门店编码', prop: 'benxiangStoreNo', width: 125 },
        { label: '档位', prop: 'levelStr', width: 65 },
        { label: '状态', prop: 'statusValue', width: 65, align: 'center' },
      ],
      storeDataList: [],
      currentRow: null,
    }
  },
  watch: {
    dialogVisible (val) {
      if (val) {
        let _this = this;

        _this.dialogViewForm = {};
        _this.dialogConnectForm = {
          id: '',
          storeId: ''
        }
        _this.tableQuery = {
          likeStoreName: '',
          likeCertificateNo: '',
          likePhone: '',
          status: '',
          limit: 500
        }
        _this.storeDataList = [];
        _this.currentRow = null;

        _this.loadChatGroupMemberData();

        _this.$nextTick(() => {
          _this.$refs.dialogConnectForm.clearValidate()
        })
      }
    }
  },
  methods: {
    theme () {
      return '#0076ff'
    },
    // 加载数据
    loadChatGroupMemberData () {
      let _this = this;
      viewWeChatContactApi({ id: _this.dataId }).then((response) => {
        const { data } = response
        _this.dialogViewForm = data;
        _this.dialogConnectForm.id = data.id;

        _this.tableQuery.status = '';
        _this.tableQuery.likePhone = '';
        _this.tableQuery.likeStoreName = data.certificatedStoreName || '';
        _this.tableQuery.likeCertificateNo = data.appUserCertificateNo || data.questionnaireCertificateNo;
        if (_this.tableQuery.likeStoreName || _this.tableQuery.likeCertificateNo) {
          _this.searchTableData();
        }
      })
    },
    // 查询零售户档案列表
    searchTableData () {
      let _this = this;
      if (!_this.tableQuery.likeStoreName && !_this.tableQuery.likeCertificateNo && !_this.tableQuery.likePhone) {
        _this.$message({ message: '请输入查询条件后获取零售户档案列表', type: 'error' })
        return
      }

      listStoreInfoApi(_this.tableQuery).then((response) => {
        const { data } = response;
        _this.storeDataList = data || [];
      }).catch(() => { })
    },
    getCurrentRow (row) {
      let _this = this;
      _this.dialogConnectForm.storeId = row.id;
    },
    // 保存
    handleSave () {
      let _this = this;
      if (!_this.dialogConnectForm.storeId) {
        _this.$message({ message: '请选择微信群成员要认证的零售户档案', type: 'error' })
        return;
      }

      _this.$confirm(
        '是否确认微信群成员认证零售户档案?', '系统提示', { confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning', center: true }
      ).then(async () => {
        connectStoreWeChatContactApi(_this.dialogConnectForm).then(() => {
          _this.$message({ message: '认证零售户档案成功', type: 'success' })
          _this.$emit('reloadData')
          _this.modalClose()
        }).catch(() => { })
      }).catch(() => { });
    },
    modalClose () {
      let _this = this;
      _this.$emit('update:dialogVisible', false)
      _this.$refs.dialogConnectForm.clearValidate()
    },
  }
}
</script>
<style lang="scss"  scoped>
.el-table--border {
  border-left: 1px solid #dfe6ec;
}
::v-deep .el-table {
  th {
    color: #ffffff;
    .cell {
      line-height: 17px;
    }
  }
}

.searchCondition {
  .el-col {
    min-height: 28px;
  }
  margin: 5px 0;
}

.connect-store-table {
  // radio label隐藏不显示
  ::v-deep .el-radio__label {
    display: none;
  }

  .img-size {
    width: 62px;
    height: 62px;
    vertical-align: middle;
  }
}
</style>
